(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asimgo-product-specs"] && !Shopify.designMode) return;
  try {
    
  function getRegionName(code) {
    var normalizedCode = code.trim().toUpperCase();

    if (!window.Intl || typeof window.Intl.DisplayNames !== 'function') return normalizedCode;

    try {
      var regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
      return regionNames.of(normalizedCode) || normalizedCode;
    } catch (error) {
      return normalizedCode;
    }
  }

  function translateCountryCodes() {
    var countryNodes = document.querySelectorAll('.iso-country-display:not(.translated)');

    countryNodes.forEach(function (node) {
      var isoCodes = node.getAttribute('data-iso');
      if (!isoCodes) return;

      var translatedCodes = isoCodes.split(',').map(function (code) {
        return getRegionName(code);
      });

      node.textContent = translatedCodes.join(', ');
      node.classList.add('translated');
    });
  }

  function createNetworkOperator(operator) {
    var trimmedOperator = operator.trim();
    var bracketStart = trimmedOperator.indexOf('[');
    var operatorName = bracketStart === -1 ? trimmedOperator : trimmedOperator.slice(0, bracketStart).trim();
    var signal = '';

    if (bracketStart !== -1) {
      var bracketEnd = trimmedOperator.indexOf(']', bracketStart);
      var bracketContent = trimmedOperator.slice(bracketStart + 1, bracketEnd === -1 ? undefined : bracketEnd);
      var networkTypes = bracketContent.split(';');
      signal = networkTypes[networkTypes.length - 1].trim();
    }

    var operatorFragment = document.createDocumentFragment();
    var operatorNameNode = document.createElement('span');
    operatorNameNode.textContent = operatorName;
    operatorFragment.appendChild(operatorNameNode);

    if (signal) {
      var signalNode = document.createElement('span');
      signalNode.className = 'asimgo-network-country-card__signal';
      signalNode.textContent = ' ' + signal;
      operatorFragment.appendChild(signalNode);
    }

    return operatorFragment;
  }

  function renderRegionCoverage() {
    var coverageDetails = document.querySelectorAll('.asimgo-coverage-details:not(.is-rendered)');

    coverageDetails.forEach(function (details) {
      var list = details.querySelector('.asimgo-coverage-list');
      var networkRaw = details.getAttribute('data-network-list');
      if (!list || !networkRaw) return;

      networkRaw.split('|').forEach(function (countryBlock) {
        var delimiterIndex = countryBlock.indexOf(':');
        if (delimiterIndex === -1) return;

        var countryCode = countryBlock.slice(0, delimiterIndex).trim();
        var operators = countryBlock.slice(delimiterIndex + 1).split(',').filter(function (operator) {
          return operator.trim() !== '';
        });
        if (!countryCode || operators.length === 0) return;

        var countryCard = document.createElement('div');
        countryCard.className = 'asimgo-network-country-card';

        var countryName = document.createElement('span');
        countryName.className = 'asimgo-network-country-card__name';
        countryName.textContent = getRegionName(countryCode);
        countryCard.appendChild(countryName);
        countryCard.appendChild(document.createTextNode(' - '));

        var operatorList = document.createElement('span');
        operatorList.className = 'asimgo-network-country-card__operators';
        operators.forEach(function (operator, index) {
          if (index > 0) {
            var separator = document.createElement('span');
            separator.className = 'asimgo-network-country-card__separator';
            separator.textContent = '|';
            operatorList.appendChild(separator);
          }
          operatorList.appendChild(createNetworkOperator(operator));
        });

        countryCard.appendChild(operatorList);
        list.appendChild(countryCard);
      });

      details.classList.add('is-rendered');
    });
  }

  translateCountryCodes();
  renderRegionCoverage();
  document.addEventListener('shopify:section:load', function () {
    translateCountryCodes();
    renderRegionCoverage();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
